module.exports = {"371072008":"皇冠街道","371072009":"凤林街道","371072010":"西苑街道","371072103":"崮山镇","371072105":"泊于镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371072.json
// module id = 1564
// module chunks = 0